//**************************************************************************************************
//  ローディング
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-loading',
  imports: [
    MatProgressSpinnerModule
  ],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
//==================================================================================================
//
//==================================================================================================
export class LoadingComponent {

}
